import { useContext, useEffect } from "react";
import { type RouteComponentProps } from "react-router";

import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { BTLocalStorage } from "types/btStorage";

import { removeJobPickerState } from "utilities/jobPicker/jobPicker";

import { BTLoading } from "commonComponents/utilities/BTLoading/BTLoading";

interface IJobPickerRouterProps extends RouteComponentProps {
    nextUrl: string;
    setSelectedJobId?: (jobId: number, orgId?: number, loadMissingJobs?: boolean) => Promise<void>;
}

// This component is used to set a job in the job picker before routing.
// Should be used sparingly until the job picker / routing is refactored.
export function JobPickerRouter({ history, nextUrl, setSelectedJobId }: IJobPickerRouterProps) {
    const userInfo = useContext(UserInfoContext);

    useEffect(() => {
        const selectJob = async (jobId: number) => {
            if (setSelectedJobId) {
                await setSelectedJobId(jobId, undefined, true);
            } else {
                // Owner portal does NOT mount JobPickerWrapper on this route — App.tsx
                // declares showJobPicker={isInPortal({ builder: true, subs: true })}, which
                // is false for owners — so setSelectedJobId is undefined. Clearing the
                // dangerousJobPickerState localStorage key is enough to break the redirect
                // loop (Sentry BTNET-REACT-5H0K, ADO 273402); we intentionally do NOT call
                // SetJobPickerData here because RequireSessionAuthenticationHandler rejects
                // owner-portal sessions with 403 (ADO 275202).
                removeJobPickerState();
            }
            let url = nextUrl;
            if (!url.startsWith("/")) {
                url = "/" + url;
            }

            if (url.startsWith("/app")) {
                url = url.replace("/app", "");
            }
            // remove after webforms is removed
            if (url.includes(".aspx")) {
                window.location.assign(url);
            } else {
                history.replace(url);
            }
        };
        const params = new URLSearchParams(history.location.search);
        const jobId = params.get("selectJobId");
        BTLocalStorage.remove("bt-object-selectedJobsiteIdWithBuilder");
        void selectJob(Number(jobId));
    }, [history, nextUrl, setSelectedJobId, userInfo?.loginType]);

    return <BTLoading />;
}
